import { PageHeader } from "@/components/ui/PageHeader";
import { EmptyState } from "@/components/ui/EmptyState";

interface Props {
  title: string;
  milestone: string;
  hint?: string;
}

export function ComingSoon({ title, milestone, hint }: Props) {
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Soon" title={title} />
      <EmptyState
        glyph="default"
        title={`The ${title} surface is on the way.`}
        description={`${milestone}. The data is live; the screen catches up next.`}
        action={
          hint ? (
            <pre className="rounded-md border border-line bg-surface-2/50 px-3 py-2 font-mono text-[11px] text-foreground/65">
              {hint}
            </pre>
          ) : undefined
        }
      />
    </div>
  );
}
